export default __webpack_public_path__ + "static/media/ac-dc.88743c17.jpg";